import { GeofenceFormModel } from '@casops/store/apis/geofencesApi';
import { useAppSelector } from '@casops/store/hooks';
import { useEffect } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

interface UseGeofenceShapeFieldProps {
  control: UseControllerProps<GeofenceFormModel>['control'];
}

export const useGeofenceShapeField = ({
  control,
}: UseGeofenceShapeFieldProps): string | undefined => {
  // Observe the geofenceEditor slice which keeps a record of 'finished' geofence edits.
  const shapeEditor = useAppSelector(state => state.geofenceEditor.shape);

  const { field, fieldState } = useController({
    control,
    name: 'shape',
  });

  // Effect to watch for shape changes and trigger field onChange.
  useEffect(() => {
    field.onBlur();
    if (shapeEditor) {
      field.onChange({ ...shapeEditor });
    } else {
      field.onChange(null);
    }
    // Intentionally exclude 'field' from the dependency array so that the effect only runs when the shapeEditor mounts or changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shapeEditor]);

  const errorMessage = fieldState.error ? fieldState.error.message : undefined;

  // If there is an issue with the shape, return the error message for display in another component.
  return errorMessage;
};

export default useGeofenceShapeField;
